//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ExceptionsService } from './exceptions-service';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class VersionService {

  private _version: string="XXXX.XX.XXXX.XX";

  get version() { return this._version; }

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClient       : HttpClient
  ) { }
  
  public async load(): Promise<void> {
    try {
      const cacheBuster=new Date().getTime();
      const data       =await firstValueFrom(
        this.httpClient.get<{ version: string }>(`assets/version.json?cb=${cacheBuster}`)
      );
      this._version=data?.version || this._version;
    } catch (e) {
      console.warn('VersionService: failed to load assets/version.json');
      this.exceptionsService.handleException(<Error>e);
    }
  };
}
